<div class="wartung">
  <div class="wartung__body">
    <div class="wartung__art">
      <svg viewBox="0 0 24 24" width="56" height="56" fill="currentColor"><path d="M12 2a4 4 0 0 0-4 4v1h8V6a4 4 0 0 0-4-4Zm-7 6a1 1 0 0 0-1 1 8 8 0 0 0 6 7.75V19H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-2v-2.25A8 8 0 0 0 20 9a1 1 0 0 0-1-1H5Z"/></svg>
      <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" class="wartung__gear"><path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/><path d="M19.4 13a7.6 7.6 0 0 0 0-2l1.7-1.3-1.6-2.8-2 .8a7.5 7.5 0 0 0-1.7-1l-.3-2.1H10l-.3 2.1a7.5 7.5 0 0 0-1.7 1l-2-.8L4.4 9.7 6.1 11a7.6 7.6 0 0 0 0 2L4.4 14.3l1.6 2.8 2-.8c.5.4 1.1.7 1.7 1l.3 2.1h3.5l.3-2.1c.6-.3 1.2-.6 1.7-1l2 .8 1.6-2.8L19.4 13Z" opacity=".55"/></svg>
    </div>
    <h1 class="wartung__title">{{ 'maintenance.page.title' | translate }}</h1>
    <p class="wartung__lead">{{ 'maintenance.page.info' | translate }}</p>
    @if (status?.infoText) {
      <div class="wartung__info">{{ status?.infoText }}</div>
    }
    @if (status?.endTime) {
      <p class="wartung__end">{{ 'maintenance.page.end' | translate: {time: (status.endTime | date: 'dd.MM.yyyy HH:mm')} }}</p>
    }
    <p class="wartung__hint">
      @if (status) {
        {{ 'maintenance.page.redirect' | translate }}
      } @else {
        {{ 'maintenance.page.unavailable' | translate }}
      }
    </p>
  </div>
</div>
